import React from 'react'

interface StepsProps {
  steps?: number;
  title: string;
  icon?: number;
  className?: string;
}

interface StepperProps {
  current: number;
  steps: StepsProps[];
  stepsColor?: string;
}

const LineBar = ({color}: {color:string}) => {
  return (
    <hr
      style={{
        color: color,
        backgroundColor: color,
        height: 5,
        width: '100%'
      }}
    />
  )
};

const MobileStepper = ({ current, steps, stepsColor }: StepperProps) => {
  return (
    <div className='grid gap-2'>
      <span className='text-xl font-normal'>{steps?.[current].title}</span>
      <div className='w-full flex gap-2'>
        {steps?.map((step, i) =>
          <LineBar color={i <= current ? '#1C64F2' : '#6B7280'} />
        )}
      </div>
      <div className='inline text-sm'>
        <span className='font-normal'>Step {current+1}/{steps?.length}</span> {steps?.length > current && steps?.[current+1]?.title}
      </div>
    </div>
  )
}

export default MobileStepper;
